import { useState, useEffect } from 'react';
import GenericAlertDialog from '@/shared/components/GenericAlertDialog';
import { setIpRestrictionAlertCallback } from '@/shared/utils/global-alert-manager';

/**
 * Global alert handler component that manages IP restriction alerts
 * This component should be placed in the App component to handle alerts triggered from anywhere
 */
export default function GlobalAlertHandler() {
  const [isIpRestrictionDialogOpen, setIsIpRestrictionDialogOpen] = useState(false);
  const [ipRestrictionMessage, setIpRestrictionMessage] = useState<string>('');

  useEffect(() => {
    const showIpRestrictionAlert = (message: string) => {
      setIpRestrictionMessage(message);
      setIsIpRestrictionDialogOpen(true);
    };

    setIpRestrictionAlertCallback(showIpRestrictionAlert);

    return () => {
      setIpRestrictionAlertCallback(() => { });
    };
  }, []);

  const handleIpRestrictionConfirm = () => {
    setIsIpRestrictionDialogOpen(false);
    setIpRestrictionMessage('');
  };

  return (
    <GenericAlertDialog
      open={isIpRestrictionDialogOpen}
      onOpenChange={setIsIpRestrictionDialogOpen}
      title="Access Restricted"
      description={ipRestrictionMessage}
      confirmLabel="Understood"
      onConfirm={handleIpRestrictionConfirm}
    />
  );
}
